import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { encodeHTML } from '@core/utils-legacy';

@Pipe({
  name: 'rtEncodeHTML',
  standalone: true,
})
export class EncodeHTMLPipe implements PipeTransform {
  public transform(value: string): string {
    return value && typeof value === 'string' ? encodeHTML(value) : value;
  }
}
